(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/assets/javascripts/views/campaign.js') >= 0) return;  svs.modules.push('/components/numbergames/results/assets/javascripts/views/campaign.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const productMapping = svs.numbergames.productMapping;
const {
  setup: {
    imageTypes
  },
  image_multi: {
    getMultiImageOptions
  }
} = svs.numbergames.picasso;
svs.numbergames.results.views.Campaign = Marionette.View.extend({
  modelEvents: {
    'results:change:draw': 'updateCampaign'
  },
  ui: {
    campaignBtn: '.js-results-campaign-btn'
  },
  triggers: {
    'click @ui.campaignBtn': 'campaignButtonClick'
  },
  template(data) {
    return data.hasCampaign ? svs.numbergames.results.templates.campaign(data) : false;
  },
  templateContext() {
    if (!this.campaign) return;
    const {
      smallImageUrl,
      largeImageUrl,
      isOpen,
      url
    } = this.campaign;
    const productName = productMapping.getProductName(this.model.get('productId'));
    const btnText = isOpen ? "Spela ".concat(productName) : 'Visa Kampanj';
    return _objectSpread({
      btnText,
      hasCampaign: true,
      href: url
    }, getMultiImageOptions(largeImageUrl, imageTypes.campaignDesktop, smallImageUrl, imageTypes.campaignMobile));
  },
  async initialize() {
    await this.updateCampaign();
  },
  onCampaignButtonClick() {
    if (!this.campaign.isOpen) {
      svs.utils.url.navigate(this.campaign.url);
      return;
    }
    Backbone.history.navigate('', {
      trigger: true
    });
  },
  async updateCampaign() {
    const productId = this.model.get('productId');
    const date = this.model.get('selectedDate');
    this.campaign = await svs.numbergames.results.radio.campaign.request('campaign', {
      productId,
      date
    });
    this.render();
  }
});

 })(window);